import { ReactElement } from "react";
import { ISample } from "../../../types";
import HtmlTooltip from "../../../components/charts/tooltip";
import { formatNumber, formatTimeWithSeconds } from "../../../system/utils";
import KeyValueItem from "../../../components/charts/keyValueItem";
import { useTheme } from "@mui/material";

interface IProps {
  chartID: string;
  title: string;
  samples: ISample[];
  y: number;
  xAccessorScaled: (sample: ISample) => number;
}


const SamplesLayerGantt = ({ samples, chartID, title, xAccessorScaled, y }: IProps): ReactElement => {
  const theme = useTheme();

  return (
    <>
      {samples.filter((x: ISample) => x.sampleDatetime && !x.sampleType.code.startsWith("FT") && !x.sampleType.code.startsWith("LT") && !x.sampleType.code.startsWith("CT")).map((item: ISample, sampleIndex: number ) => {
      // {samples.map((item: ISample, sampleIndex: number ) => {
        const sampleKey = `${chartID}-sample-${sampleIndex}`;

        return (
          <g key={sampleKey}>
            <HtmlTooltip title={
              <div>
                <div className="display-flex-column align-items-center" >
                  <strong>Sample</strong>
                  <strong>{title}</strong>
                  <strong>{`${item.sampleType.machine} / ${item.sampleType.code}`}</strong>
                  <strong style={{ fontSize: "0.9em" }}>{item.sampleDatetime ? formatTimeWithSeconds(item.sampleDatetime) : "---"}</strong>
                </div>
                {item.items.map((variable, index) => <KeyValueItem key={`${sampleKey}-item-${index}`} name={variable.name}  value={formatNumber(variable.value, 4)} /> )}
              </div>
            }>
              <g transform={`translate(${xAccessorScaled(item) - 4}, ${y})`}>
                <polygon fill={"green"} stroke={theme.palette.text.primary} points="5 0 0 5 5 10 10 5 5 0"/>
              </g>
            </HtmlTooltip>
          </g>
        );
      })
      }
    </>
  );
};

export default SamplesLayerGantt;
